import { createActions } from 'redux-actions';
import _ from 'lodash';

export const getIdentityActions = list => list.reduce((map, actionName) =>
  ({ ...map, [actionName]: _.identity }), {});

export const createNS = (ns, values) => {
  const path = ns.split('.');
  const result = {};
  let ref = {};

  path.reduce((head, key) => {
    Object.assign(head, { [key]: {} });
    ref = head[key];
    return ref;
  }, result);

  Object.assign(ref, values);

  return result;
};

export const updateStateReducer = (state, { payload: updates }) =>
  ({ ...state, ...updates });

export const createNSActions = (ns, actions, identityActions) =>
  createActions(createNS(ns, { ...actions, ...getIdentityActions(identityActions) }));



// WEBPACK FOOTER //
// ./src/utils/redux.js